const initialState = {

}

export default (state = initialState, action) => {
  switch(action.type) {
    case 'NAVIGATION_LOAD_PROGRESS_SUCCESS':
      return Object.assign({}, state, {
        progress: {...action.payload},
      })

    case 'NAVIGATION_SET_PROGRESS_SUCCESS':
      return Object.assign({}, state, {
        progress: {
          ...state.progress,
          [action.payload.id]: action.payload.data,
        },
      })

    default:
      return state
  }
}
